var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossWithoutCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon cross",
    viewBox: "0 0 12.998 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.104 12.503-3.605-3.6-3.6 3.6a1.7 1.7 0 0 1-2.4 0 1.7 1.7 0 0 1 0-2.4l3.6-3.6-3.6-3.6a1.7 1.7 0 0 1 0-2.4 1.7 1.7 0 0 1 2.4 0l3.6 3.6 3.605-3.6a1.7 1.7 0 0 1 2.4 0 1.7 1.7 0 0 1 0 2.4l-3.6 3.6 3.6 3.6a1.7 1.7 0 0 1 0 2.4 1.692 1.692 0 0 1-1.2.5 1.679 1.679 0 0 1-1.2-.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossWithoutCircleIcon);
export default __webpack_public_path__ + "static/media/cross-without-circle-icon.c017c7d10aba1977a5017329ea5f0f37.svg";
export { ForwardRef as ReactComponent };